<template>
  <el-dialog
    :visible="visible"
    :title="title"
    :width="width"
    :top="top"
    :close-on-click-modal="closeOnClickModal"
    :append-to-body="appendToBody"
    :destroy-on-close="destroyOnClose"
    class="krj-standard-dialog"
    @update:visible="onUpdateVisible"
    @close="handleClose">
    <slot />
    <slot v-if="showFooter" name="footer" slot="footer">
      <div class="krj-dialog-footer">
        <el-button size="small" @click="handleCancel">{{ cancelText }}</el-button>
        <el-button
          size="small"
          :type="confirmType"
          :loading="loading"
          :disabled="confirmDisabled"
          @click="$emit('confirm')">
          {{ confirmText }}
        </el-button>
      </div>
    </slot>
  </el-dialog>
</template>

<script>
export default {
  name: 'StandardDialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    width: { type: String, default: '560px' },
    top: { type: String, default: '8vh' },
    showFooter: { type: Boolean, default: true },
    confirmText: { type: String, default: '保 存' },
    cancelText: { type: String, default: '取 消' },
    confirmType: { type: String, default: 'primary' },
    confirmDisabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    closeOnClickModal: { type: Boolean, default: false },
    appendToBody: { type: Boolean, default: true },
    destroyOnClose: { type: Boolean, default: true }
  },
  methods: {
    onUpdateVisible(val) {
      this.$emit('update:visible', val)
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    handleCancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    }
  }
}
</script>
